import React, { useState, useRef, useEffect } from 'react';
import './tabs.css';
import TabCard from '../tabs/TabCard';
import { AnimatePresence, motion } from 'framer-motion';
// AI/ML Tools icons
import hggfc from '../../../assets/hggfc.svg';
import opnai from '../../../assets/opnai.svg';
import tnsrfl from '../../../assets/tnsr.svg';
// DB icons
import msql from '../../../assets/msql.svg';
import pstgrs from '../../../assets/pstgrs.svg';
import mongodb from '../../../assets/mongodb.svg';
// Dev envs
import grafana from '../../../assets/grafana-logoo-removebg.png';
import vsc from '../../../assets/vsc.svg';
import airflow from '../../../assets/airflow.svg';
// Cloud Platforms
import gcp from '../../../assets/gcp.svg';
import azure from '../../../assets/azure.svg';
import aws from '../../../assets/aws-white.svg';

const tabList = ['AI/ML Tools', 'Databases', 'Development Environments', 'Cloud Platforms'];

const tabIcons = {
    0: [tnsrfl, hggfc, opnai],
    1: [msql, pstgrs, mongodb],
    2: [vsc, airflow, grafana],
    3: [aws, azure, gcp],
};

const Tabs = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [sliderStyle, setSliderStyle] = useState({});
    const tabRefs = useRef([]);

    useEffect(() => {
        const currentTab = tabRefs.current[activeTab];
        if (currentTab) {
            setSliderStyle({
                width: currentTab.offsetWidth + 'px',
                left: currentTab.offsetLeft + 'px',
            });
        }
    }, [activeTab]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            {/* Tab bar */}
            <div className="tabs-outer-wrapper">
                <div className="tabs-wrapper">
                    <div className="tab-slider" style={sliderStyle} />
                    {tabList.map((tab, index) => (
                        <button
                            key={index}
                            ref={(el) => (tabRefs.current[index] = el)}
                            className={`tab-button ${activeTab === index ? 'active' : ''}`}
                            onClick={() => setActiveTab(index)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            </div>

            {/* Icon Cards Section */}
            <div className="tab-icons-wrapper">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeTab} // re-renders on change
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.4 }}
                        className="tab-cards-grid"
                    >
                        {tabIcons[activeTab].map((icon, i) => (
                            <TabCard key={i} icon={icon} />
                        ))}
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};

export default Tabs;
